import { render, staticRenderFns } from "./imgPreview.vue?vue&type=template&id=af3dd248&scoped=true"
import script from "./imgPreview.vue?vue&type=script&lang=js"
export * from "./imgPreview.vue?vue&type=script&lang=js"
import style0 from "./imgPreview.vue?vue&type=style&index=0&id=af3dd248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3dd248",
  null
  
)

export default component.exports